<script context="module">
  export function convertSecToMin(timeInSec) {
    let mins = ~~((timeInSec % 3600) / 60);
    let secs = ~~timeInSec % 60;
    let formattedTime = (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;
    return formattedTime
  }

  export function formatNumberWith4Colors(value, defaultValue = "") {
    if (!value) {
      return defaultValue;
    }
    const num = Number.parseFloat(value);
    if (num) {
      return num.toFixed(0);
    }
    return defaultValue;
  }

  export function average(arr) {
    return arr.reduce((p, c) => p + c, 0) / arr.length;
  }

  export function formatDateToLocale(timestamp) {
    if (!timestamp) {
      return null;
    }
    return new Date(timestamp+"Z").toLocaleString();
  }

  export function generateUUID() {
    // Public Domain/MIT
    let d = new Date().getTime(); //Timestamp
    let d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        let r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  export function normalizedScoreToLevelTOEICSpeaking(value) {
    if (value < 0 || value > 1) {
        throw new Error("Value must be between 0 and 1");
    }
    
    const levels = [
        { level: 8, min: 190, max: 200 },
        { level: 7, min: 160, max: 180 },
        { level: 6, min: 130, max: 150 },
        { level: 5, min: 110, max: 120 },
        { level: 4, min: 80, max: 100 },
        { level: 3, min: 60, max: 70 },
        { level: 2, min: 40, max: 50 },
        { level: 1, min: 0, max: 30 },
    ];
    
    // Map value (0 to 1) to the score range (0 to 200)
    let score = Math.round(value * 200 / 10) * 10;
    
    // Determine level based on score
    let level = levels.find(l => score >= l.min && score <= l.max)?.level || 1;
    
    return { score, level };
}

export function normalizedScoreToLevelTOEICReading(value) {
    if (value < 0 || value > 1) {
        throw new Error("Value must be between 0 and 1");
    }
    
    const levels = [
        { level: 5, min: 455, max: 495 },
        { level: 4, min: 385, max: 450 },
        { level: 3, min: 375, max: 380 },
        { level: 2, min: 115, max: 270 },
        { level: 1, min: 5, max: 110 },
    ];
    
    // Map value (0 to 1) to the score range (5 to 495)
    let score = 5 + Math.round(value * 490 / 5) * 5;
    
    // Determine level based on score
    let level = levels.find(l => score >= l.min && score <= l.max)?.level || 1;
    
    return { score, level };
}

export function normalizedScoreToLevelTOEICListening(value) {
    if (value < 0 || value > 1) {
        throw new Error("Value must be between 0 and 1");
    }
    
    const levels = [
        { level: 5, min: 400, max: 495 },
        { level: 4, min: 300, max: 390 },
        { level: 3, min: 200, max: 290 },
        { level: 2, min: 100, max: 190 },
        { level: 1, min: 5, max: 90 },
    ];
    
    // Map value (0 to 1) to the score range (5 to 495)
    let score = 5 + Math.round(value * 490 / 5) * 5;
    
    // Determine level based on score
    let level = levels.find(l => score >= l.min && score <= l.max)?.level || 1;
    
    return { score, level };
}

export function normalizedScoreToLevel100(value) {

    if (!Number(value)){
      return { score: 0, level: 1};
    }

    if (value < 0 || value > 1) {
        throw new Error("Value must be between 0 and 1");
    }
    
    const levels = [
        { level: 5, min: 80, max: 100 },
        { level: 4, min: 60, max: 70 },
        { level: 3, min: 40, max: 50 },
        { level: 2, min: 20, max: 30 },
        { level: 1, min: 0, max: 10 },
    ];
    
    // Map value (0 to 1) to the score range (0 to 200)
    let score = Math.round(value * 100 / 10) * 10;
    
    // Determine level based on score
    let level = levels.find(l => score >= l.min && score <= l.max)?.level || 1;
    
    return { score, level };
}
</script>
